import { render } from "./MerchandisesViews.vue?vue&type=template&id=1ef30355&scoped=true"
import script from "./MerchandisesViews.vue?vue&type=script&lang=js"
export * from "./MerchandisesViews.vue?vue&type=script&lang=js"

import "./MerchandisesViews.vue?vue&type=style&index=0&id=1ef30355&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef30355"]])

export default __exports__